const e = {
  name: "NumberThreeCircleFilled",
  dimensions: { width: 40, height: 40 },
  content: `
    <g clip-path="url(#clip0_12_1911)">
    <path d="M20 40.033C31.0457 40.033 40 31.0787 40 20.033C40 8.98726 31.0457 0.032959 20 0.032959C8.9543 0.032959 0 8.98726 0 20.033C0 31.0787 8.9543 40.033 20 40.033Z" fill="currentColor"/>
    <path d="M17.5 17.533C17.5 17.0385 17.6466 16.5552 17.9213 16.144C18.196 15.7329 18.5865 15.4125 19.0433 15.2233C19.5001 15.034 20.0028 14.9845 20.4877 15.081C20.9727 15.1775 21.4181 15.4156 21.7678 15.7652C22.1174 16.1148 22.3555 16.5603 22.452 17.0452C22.5484 17.5302 22.4989 18.0329 22.3097 18.4897C22.1205 18.9465 21.8 19.3369 21.3889 19.6116C20.9778 19.8863 20.4945 20.033 20 20.033" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
    <path d="M20 20.033C20.4945 20.033 20.9778 20.1796 21.3889 20.4543C21.8 20.729 22.1205 21.1194 22.3097 21.5763C22.4989 22.0331 22.5484 22.5357 22.452 23.0207C22.3555 23.5056 22.1174 23.9511 21.7678 24.3007C21.4181 24.6504 20.9727 24.8885 20.4877 24.9849C20.0028 25.0814 19.5001 25.0319 19.0433 24.8427C18.5865 24.6534 18.196 24.333 17.9213 23.9219C17.6466 23.5108 17.5 23.0274 17.5 22.533" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
    </g>
    <defs>
    <clipPath id="clip0_12_1911">
    <rect width="40" height="40" fill="white" transform="translate(0 0.032959)"/>
    </clipPath>
    </defs>

    `
};
export {
  e as NumberThreeCircleFilled
};
